// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"bf545070","230":"bf545070","652":"36560f88","732":"bf545070","807":"bf545070","842":"f1ef16c3","879":"bf545070"}[chunkId] + ".chunk.css";
};